export type TourSortViewPropertiesType = {
  orderBy: string;
  sorts: Array<SortType>;
};

export type SortType = {
  label: string;
  value: SORT_OPTIONS;
};

export enum SORT_OPTIONS {
  RECOMMENDED = "recommended",
  CHEAPEST = "cheapest",
  EXPENSIVE = "expensive",
  SUGGESTED = "SUGGESTED",
  CHEAPEST_TOUR_GROUP = "CHEAPEST",
  MOST_EXPENSIVE = "MOST_EXPENSIVE"
}
